import { Bell, KeyRound, type LucideIcon } from 'lucide-react';
import { type NavArea, visibleItem } from '../navigation.ts';

/**
 * Atalho do "Meu dia a dia" no Início. Só aponta para telas que já existem e que a pessoa pode
 * abrir: a regra é a mesma do menu (`visibleAreas`), sem lista nem permissão própria.
 */
export interface HomeShortcut {
  id: string;
  to: string;
  icon: LucideIcon;
  /** Nome do atalho (chave de tradução). */
  titleKey: string;
  /** Linha de apoio fixa (chave), quando não há contagem: o departamento ou o que a tela mostra. */
  captionKey?: string;
  /** Contagem que vem da própria tela de destino (nunca um número inventado). */
  count?: 'notifications';
}

/** Saudação pela hora de quem abre o Início (no fuso do navegador dela). */
export function greetingKey(
  now: Date,
): 'home.greetingMorning' | 'home.greetingAfternoon' | 'home.greetingEvening' {
  const hour = now.getHours();
  if (hour >= 5 && hour < 12) return 'home.greetingMorning';
  if (hour >= 12 && hour < 18) return 'home.greetingAfternoon';
  return 'home.greetingEvening';
}

/** Telas de administração que aparecem como atalho para quem pode abri-las. */
const ADMIN_SHORTCUTS = ['/settings/users', '/settings/groups', '/settings/audit'];

export function homeShortcuts(areas: NavArea[]): HomeShortcut[] {
  // Os avisos pessoais e as configurações da pessoa são de todos: cada pessoa vê só os seus.
  const list: HomeShortcut[] = [
    {
      id: 'notifications',
      to: '/notifications',
      icon: Bell,
      titleKey: 'home.notifications',
      count: 'notifications',
    },
    {
      id: 'myAccess',
      to: '/account',
      icon: KeyRound,
      titleKey: 'home.myAccess',
      captionKey: 'home.myAccessHint',
    },
  ];
  // Módulo novo: acrescente aqui o atalho do dia a dia dele (sempre por `visibleItem`).
  for (const to of ADMIN_SHORTCUTS) {
    const item = visibleItem(areas, to);
    if (item)
      list.push({ id: to.split('/').pop()!, to: item.to, icon: item.icon, titleKey: item.key });
  }
  return list;
}
